import { Currency } from '@/core/currency/interfaces';

const SOS: Currency = {
    name: 'Somali Shilling',
    demonym: 'Somali',
    majorSingle: 'Shilling',
    majorPlural: 'Shillings',
    codeNumeric: '706',
    symbol: 'Sh.So.',
    symbolNative: 'Ssh',
    minorSingle: 'Senti',
    minorPlural: 'Senti',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SOS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SOS;
